import styled from 'styled-components'
import { mobileBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Container = styled.div`
    background-color: ${props => props.theme.colors.white};
    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        margin-bottom: 100px;
    }
`

export const InnerContainer = styled.div`
    max-width: 83rem;
    margin: 0 auto;
`

// GYGExperiencesSection's Container has padding-right but no padding-left by design
// (left is 0 so callers can control alignment). These values mirror the right-side
// padding values from the shared component's Container breakpoints.
export const GYGWrapper = styled.div`
    padding-left: 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding-left: 1.5rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding-left: 4rem;
    }
`
